import { forwardRef } from "react"

import type { SX } from "../../theme"
import { BaseInput } from "../BaseInput"
import type { BaseInputProps } from "../BaseInput/BaseInput"

export interface TextInputProps {
  inputMode?: "text"
  name?: string
  id?: BaseInputProps["id"]
  placeholder?: BaseInputProps["placeholder"]
  readOnly?: BaseInputProps["readOnly"]
  value: BaseInputProps["value"]
  startAdornment?: BaseInputProps["startAdornment"]
  endAdornment?: BaseInputProps["endAdornment"]
  padding?: BaseInputProps["padding"]
  variant?: BaseInputProps["variant"]
  maxLength?: BaseInputProps["maxLength"]
  cursor?: BaseInputProps["cursor"]
  textOverflow?: BaseInputProps["textOverflow"]
  sx?: SX
  onKeyDown?: BaseInputProps["onKeyDown"]
  onValueChange?: BaseInputProps["onValueChange"]
  onFocus?: BaseInputProps["onFocus"]
  onBlur?: BaseInputProps["onBlur"]
  onPaste?: BaseInputProps["onPaste"]
  onClick?: BaseInputProps["onClick"]
}

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  function TextInput(props, ref) {
    const { inputMode = "text", ...otherProps } = props
    return <BaseInput {...otherProps} ref={ref} inputMode={inputMode} />
  },
)
